import { useLocation, Link } from "react-router-dom";
import {
  Navbar,
  Typography,
  IconButton,
  Breadcrumbs,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
} from "@material-tailwind/react";
import {
  UserCircleIcon,
  Bars3Icon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/solid";
import {
  useMaterialTailwindController,
  setOpenSidenav,
} from "@/context";
import Swal from "sweetalert2";
import { clearUser, logout } from "@/store/slices/userSlice";
import { persistor, RESET_STORE } from "@/store/slices";
import Toaster from "../../components/Toaster";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Language from "@/components/Language";

export function DashboardNavbar() {
  const _dispatch = useDispatch();
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialTailwindController();
  const { fixedNavbar, openSidenav } = {
    fixedNavbar: true,
    openConfigurator: true,
    openSidenav: false,
    sidenavColor: "dark",
    sidenavType: "white",
    transparentNavba: true,
  };
  const { pathname } = useLocation();

  const [layout, page] = pathname.split("/").filter((el) => el !== "");
  const segments = pathname.split("/").filter(Boolean);
  
  const { user } = useSelector((state) => state.user);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        const clearStoreAndRedirect = () => {
          _dispatch(clearUser());
          _dispatch({ type: RESET_STORE });

          // Remove token and any app auth keys
          localStorage.removeItem("token");

          // Clear all Redux Persist keys (persist:root, etc.) so dev tools show no stale data
          Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("persist:")) {
              localStorage.removeItem(key);
            }
          });

          // Purge persistor, then force full page reload so app rehydrates from empty storage
          persistor.purge().then(() => {
            Toaster.success("Logged out successfully!");
            window.location.href = "/sign-in";
          }).catch((err) => {
            console.error("Purge failed:", err);
            Toaster.success("Logged out successfully!");
            window.location.href = "/sign-in";
          });
        };
        _dispatch(logout())
          .unwrap()
          .then(() => clearStoreAndRedirect())
          .catch((error) => {
            console.error("Logout API failed:", error);
            clearStoreAndRedirect();
          });
      }
    });
  };

  return (

    
    // <Navbar
    //   color={fixedNavbar ? "white" : "transparent"}
    //   className={`rounded-xl transition-all ${fixedNavbar
    //       ? "sticky top-4 z-40 py-3 shadow-md shadow-blue-gray-500/5"
    //       : "px-0 py-1"
    //     }`}
    //   fullWidth
    //   blurred={fixedNavbar}
    // >
    //   <div className="flex flex-col-reverse justify-between gap-6 md:flex-row md:items-center">
    //     {/* Breadcrumbs */}
    //     <div className="capitalize">
    //       <Breadcrumbs
    //         className={`bg-transparent p-0 transition-all ${fixedNavbar ? "mt-1" : ""
    //           }`}
    //       >
    //         <Link to={`/${layout}/home`}>
    //           <Typography
    //             variant="small"
    //             color="blue-gray"
    //             className="font-normal opacity-50 transition-all hover:text-blue-500 hover:opacity-100"
    //           >
    //             {layout}
    //           </Typography>
    //         </Link>
    //         {segments[1] && (
    //           <Link to={`/${layout}/${segments[1]}`}>
    //             <Typography
    //               variant="small"
    //               color="blue-gray"
    //               className="font-normal opacity-50 transition-all hover:text-blue-500 hover:opacity-100"
    //             >
    //             {segments[1]}
    //           </Typography>
    //           </Link>
    //         )}
    //         {segments[2] && (
    //             <Typography
    //               variant="small"
    //               color="blue-gray"
    //               className="font-normal opacity-50 transition-all hover:text-blue-500 hover:opacity-100"
    //             >
    //             {segments[2]}
    //           </Typography>
    //         )}
    //       </Breadcrumbs>
    //        <Typography variant="h6" color="blue-gray">
    //         {page?.replace(/-/g, " ")}
    //       </Typography>
    //     </div>

    //     {/* Right Side */}
    //     <div className="flex items-center gap-2">
    //       {/* Sidenav Toggle */}
    //       <IconButton
    //         variant="text"
    //         color="blue-gray"
    //         className="grid xl:hidden"
    //         onClick={() => setOpenSidenav(dispatch, !openSidenav)}
    //       >
    //         <Bars3Icon strokeWidth={3} className="h-6 w-6 text-blue-gray-500" />
    //       </IconButton>
          
    //       {(page === "categories" || page === "products") && <Typography variant="h6" color="blue-gray">
    //         <Language/>
    //       </Typography>}

    //       {/* Profile Dropdown */}
    //       {/* Profile Dropdown */}
    //       <Menu placement="bottom-end">
    //         <MenuHandler>
    //           <Avatar
    //             src={user?.profile_image ? user.profile_image : '/img/team-1.jpeg'}
    //             alt={user?.first_name}
    //             className="h-12 w-12 cursor-pointer border-2 border-white shadow-lg"
    //           />
    //         </MenuHandler>
    //         <MenuList className="w-64 p-1 font-sans">
    //           {/* --- User Info Header --- */}
    //           <div className="flex items-center gap-3 p-3 border-b border-blue-gray-50 bg-blue-gray-50/50 rounded-t-lg">
    //             <Avatar
    //               src={user?.profile_image ? user.profile_image : '/img/team-1.jpeg'}
    //               alt={user?.first_name}
    //               size="lg"
    //               className="border-2 border-white"
    //             />
    //             <div>
    //               <Typography variant="h6" className="text-blue-gray-900">
    //                 {user?.first_name} { user?.last_name ? user?.last_name : ''}
    //               </Typography>
    //               <Typography variant="small" className="font-normal text-gray-600">
    //                 {user?.email}
    //               </Typography>
    //             </div>
    //           </div>

    //           {/* --- Menu Items --- */}
    //           <MenuItem className="my-1">
    //             <Link to="/dashboard/profile">
    //             <div className="flex items-center gap-3 text-blue-gray-700">
    //               <UserCircleIcon className="h-5 w-5" />
    //               <Typography variant="small" className="font-semibold">
    //                 My Profile
    //               </Typography>
    //               </div>
    //               </Link>
    //           </MenuItem>

    //           <hr className="my-1 border-blue-gray-50" />

    //           <MenuItem
    //             onClick={handleLogout}
    //             className="my-1 hover:!bg-red-500/10 focus:!bg-red-500/10 active:!bg-red-500/10"
    //           >
    //             <div className="flex items-center gap-3 text-red-500">
    //               <ArrowRightOnRectangleIcon className="h-5 w-5" />
    //               <Typography variant="small" className="font-semibold">
    //                 Logout
    //               </Typography>
    //             </div>
    //           </MenuItem>
    //         </MenuList>
    //       </Menu>
    //     </div>
    //   </div>
    // </Navbar>


     <div>      
      <IconButton variant="text" color="blue-gray" className="grid xl:hidden" onClick={() => setOpenSidenav(dispatch, !openSidenav)}>
        <Bars3Icon strokeWidth={3} className="h-6 w-6 text-blue-gray-500" /></IconButton>
      </div>
  );
}

DashboardNavbar.displayName = "/src/widgets/layout/dashboard-navbar.jsx";

export default DashboardNavbar;